import mentoriaApi from "./axiosTokenMiddleware";

const mentoriaURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL || "";
const mentoriaApiKey = process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY || "";
const mentoriaScheduleURL = process.env.REACT_APP_MENTORIA_FINANCIERA_SCHEDULE_URL;


export const getChallenges = async (jwt:  string) => {
		return await mentoriaApi.get(mentoriaURL + "getChallenges", {
			headers: {
				"Content-Type": "application/json",
				ApiKey: mentoriaApiKey,
				Authorization: `Bearer ${jwt}`,
			},
		});
};

export const saveCompleteChallenge = (idChallenge: number, challengeIdx: string) => {
	return mentoriaApi.post(mentoriaURL + "saveCompleteChallenge",
		challengeIdx,
		{
			headers: {
				"Content-Type": "application/json",
				ApiKey: mentoriaApiKey,
				idChallenge: idChallenge
			},
		});
};

export const sendSchedule = (
	payload: Array<{ day: string; times: Array<string> }>
) => {
	return mentoriaApi.post(mentoriaScheduleURL + "saveSchedule", payload, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey,
		},
	});
};

export const getUserState = () => {
	return mentoriaApi.get(mentoriaURL + "getCurrentStateByUser", {
		headers: {
			ApiKey: mentoriaApiKey
		},
	});
};


export const getQuestionsByCourse = async () => {
	return mentoriaApi.get(mentoriaURL + "getQuestionsByCourse/Curso Oncredit", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const getFinalScoreOncredit = async () => {
	return mentoriaApi.get(mentoriaURL + "getFinalScoreOncredit", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const saveFinalScoreOncredit = async (score: number) => {
	return mentoriaApi.post(mentoriaURL + "saveFinalScoreOncredit", score, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const validateIfcompleteCourse = async (docId: string, typeDoc: string) => {
	return mentoriaApi.get(mentoriaURL + "validateIfcompleteCourse", {
	  params: {
		document: docId,
		documentCode: typeDoc
	  },
	  headers: {
		"Content-Type": "application/json",
		ApiKey: mentoriaApiKey
	  }
	});
  };